export const SIZE = 6
